export const PresentRouting = [
  {
    path: "/work-manage/present/list",
    name: "work-manage-present-list",
    meta: { title: "项目交底" },
    notice: { type: "project_presentation_examine", hasNotice: false },
    component: () => import("@/views/work-manage/present/list/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/present/create",
    name: "work-manage-present-create",
    meta: { title: "新增项目交底",comName:"workManagePresentFormCreate" },
    component: () => import("@/views/work-manage/present/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/present/edit/:id",
    name: "work-manage-present-edit",
    meta: { title: "编辑项目交底",comName:"workManagePresentFormCreate" },
    component: () => import("@/views/work-manage/present/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/present/detail/:id",
    name: "work-manage-present-detail",
    meta: { title: "项目交底详情" },
    component: () => import("@/views/work-manage/present/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/present/flowPrint/:id",
    name: "work-manage-present-flow-print",
    meta: { title: "打印详情" },
    component: () => import("@/views/work-manage/present/flow-print/index.vue"),
  }
];
